import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Modal, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'
import Select from 'react-select'
import { getLockers } from '../../../utils/lockers-webapi'

export default class ConvertToBoxModal extends Component {
    constructor(...args) {
        super(...args)
        this.state = {
            lockers: [],
            inNumber: null,
            error: null,
            prevShow: false,
        }
    }

    static getDerivedStateFromProps(props, state) {
        // on new opens, reset state
        if (props.show && !state.prevShow) {
            return {
                lockers: [],
                inNumber: null,
                error: null,
                prevShow: props.show,
            }
        }
        // track previous show state
        if (!props.show && state.prevShow) {
            return {
                prevShow: props.show,
            }
        }
        return null
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            this.fetchLockers()
        }
    }

    fetchLockers() {
        getLockers(this.props.countryCode, this.props.postalCode, true)
            .then((res) => {
                this.setState({ lockers: res.lockers, error: null })
            })
            .catch((e) => {
                this.setState({ lockers: [], error: e.message || 'Failed to load lockers' })
            })
    }

    handleClose = () => {
        this.setState({
            lockers: [],
            inNumber: null,
            error: null,
        })
        this.props.onClose()
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Convert to box delivery</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.error && <div className="alert alert-danger">{this.state.error}</div>}
                    <form>
                        <FormGroup>
                            <ControlLabel>Budbee Locker</ControlLabel>
                            <Select
                                placeholder="Select a locker"
                                value={this.state.inNumber}
                                options={(this.state.lockers || []).map((locker) => ({
                                    value: locker.lockerIdentifier,
                                    label: locker.lockerAddress.name,
                                }))}
                                onChange={(option) => {
                                    this.setState({ inNumber: option.value })
                                }}
                                clearable={false}
                                ignoreCase
                            />
                        </FormGroup>
                        <div className="info alert-info">
                            <strong>NB!</strong> The list includes Budbee-only or mixed (Budbee/Instabox) lockers.
                        </div>

                        <FormGroup style={{ marginTop: '20px' }}>
                            <ControlLabel>Or enter Budbee locker inNumber manually</ControlLabel>
                            <FormControl
                                type="text"
                                placeholder="Enter locker in-number e.g. SN215"
                                value={this.state.inNumber || ''}
                                onChange={(e) => this.setState({ inNumber: e.target.value.toUpperCase() })}
                            />
                        </FormGroup>
                        <div className="alert alert-warning">
                            <strong>Warning:</strong> Make sure the locker supports Budbee brand if you enter the
                            in-number manually.
                        </div>
                    </form>
                    <p>Are you sure you want to convert this order to box delivery from home delivery?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.handleClose}>Close</Button>
                    <Button
                        bsStyle="danger"
                        disabled={!this.state.inNumber}
                        onClick={() => this.props.onSuccess(this.state.inNumber)}
                    >
                        Yes, convert to box
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}
ConvertToBoxModal.propTypes = {
    show: PropTypes.bool.isRequired,
    countryCode: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
}
